import React from 'react'
import debounce from 'debounce'
import { GetSearchTerm, GetDetail, GetAISearch } from '../Api'
import Config from '../Config'
const { ToastTip, platform, Pushgtagpiwikurl, Pushgtagdata } = Config()

const PageSize = 10
const MaxLength = 50

export default class SearchCom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchResultObj: {
                searchCount: 0,
                searchResult: []
            },
            searchResultAI: '',
            currentPaginationIndex: 1,

            questionIndex: -9999,
            knowledgeBaseID: '',
            isSubmitEditing: false
        }

        this.handleSearch = debounce(this.handleSearch.bind(this), 300) // 300ms 的延迟
    }


    componentDidMount() {

    }

    async handleSearch() {
        const { searchText, isSubmitEditing } = this.state
        let { routerName } = this.props
        let tempSearchText = searchText
        if (tempSearchText?.length) {
            const searchResultObj = await GetSearchTerm(tempSearchText)
            this.setState({
                searchResultObj,
            })

            let { searchResult = [] } = searchResultObj
            if (searchResult.length && platform == 'Mobile' && isSubmitEditing && !routerName.includes('QuestionDetail')) {
                this.props?.RouterSearch(`Search/isBackPage`)
            }
        } else {
            this.setState({
                searchResultObj: {
                    searchCount: 0,
                    searchResult: []
                },
                currentPaginationIndex: 1
            })
        }
    }



    async changeSearchText({
        searchText = this.state.searchText,
        isSubmitEditing = this.state.isSubmitEditing,
        questionIndex,
        isClick = false,
        isSearch = false,
        isAiSearch = false,
        callBack = () => { }
    }) {
        let { searchResultObj } = this.state
        let { searchResult } = searchResultObj


        // if (isClick) {
        //     if (searchText.trim().length <= 0) {
        //         ToastTip.error(this.props.tempText?.text79)
        //         return
        //     }
        // }

        if (questionIndex >= 0 && questionIndex != this.state.questionIndex && Array.isArray(searchResult) && searchResult.length && !searchResult[questionIndex]?.content) {
            let knowledgeBaseID = searchResult[questionIndex]?.knowledgeBaseID
            if (knowledgeBaseID) {
                let res = await GetDetail({ knowledgeBaseID })
                let { content } = res
                searchResult[questionIndex].content = content
            }
        }

        this.setState({
            searchText,
            questionIndex,
            isSubmitEditing,
        }, async () => {
            callBack()
            if (isSearch) {
                this.setState({
                    searchResultAI: ' '
                })
                if (isAiSearch) {
                    let data = await GetAISearch({
                        text: searchText
                    })
                    this.setState({
                        searchResultAI: data
                    })
                    return
                } else {
                    this.handleSearch()
                }
            }

        })
    }

    changePaginationIndex(currentPaginationIndex) {
        if (currentPaginationIndex == this.state.currentPaginationIndex) return
        this.setState({
            currentPaginationIndex
        })
    }




    render() {
        const { searchText, searchResultObj, currentPaginationIndex, isSubmitEditing, questionIndex, searchResultAI, isAiDetail } = this.state
        const { Content } = this.props
        const { searchCount, searchResult } = searchResultObj

        return <>
            <Content
                maxLength={MaxLength}
                searchText={searchText}
                searchCount={searchCount}
                searchResultAI={searchResultAI}
                isAiDetail={isAiDetail}
                searchResultTop={searchResult}
                searchResultBottom={searchResult.slice(PageSize * (currentPaginationIndex - 1), PageSize * (currentPaginationIndex - 1) + PageSize)}
                changeSearchText={this.changeSearchText.bind(this)}

                changePaginationIndex={this.changePaginationIndex.bind(this)}
                currentPaginationIndex={currentPaginationIndex}
                totalPaginationNum={Math.ceil(searchResult.length / PageSize)}

                questionIndex={questionIndex}
                isSubmitEditing={isSubmitEditing}
            ></Content>
        </>
    }
}